<template>
     <section class="features-sec position-relative">
        <div class="container">
            <h2 class="lh-1 fs54 fw-bold titleColor mb-3 mb-lg-4 text-center" data-aos="fade-up" data-aos-duration="600" data-aos-delay="300">{{$t("demo_account.sub_heading1_our")}} <span class="textPrimary">{{$t("demo_account.sub_heading1_features")}}</span></h2>
            <p class="fs22 mb-4 mb-md-5 pb-0 fw-medium text-center" data-aos="fade-up" data-aos-duration="600" data-aos-delay="400">{{$t("demo_account.sub_heading1_title")}}</p>
            <div class="content-sec position-relative">
                <div class="row">
                    <!-- item -->
                    <div class="col-md-6 col-lg-3 py-3" data-aos="fade-up" data-aos-duration="600" data-aos-delay="500">
                        <div class="flip-card" tabIndex="0">
                            <div class="flip-card-inner text-center">
                            <div class="flip-card-front">
                                <img class="img-fluid mb-4" src="/static/fxView/images/lp/featureone.svg">
                                <h3 class="titleColor fs20 fw-semiBold mb-3 pt-3">{{$t("demo_account.sub_heading1_sub_container1_in_depth")}} <br>{{$t("demo_account.sub_heading1_sub_container1_learning")}}</h3>
                            </div>
                            <div class="flip-card-back">
                                <p class="mb-4">{{$t("demo_account.sub_heading1_sub_container1_description")}}</p>
                            </div>
                            </div>
                        </div>
                    </div>

                    <!-- item -->
                    <div class="col-md-6 col-lg-3 py-3" data-aos="fade-up" data-aos-duration="600" data-aos-delay="600">
                        <div class="flip-card" tabIndex="0">
                            <div class="flip-card-inner text-center">
                            <div class="flip-card-front">
                                <img class="img-fluid mb-4" src="/static/fxView/images/lp/featuretwo.svg">
                                <h3 class="titleColor fs20 fw-semiBold mb-3 pt-3">{{$t("demo_account.sub_heading1_sub_container2_risk_free")}} <br> {{$t("demo_account.sub_heading1_sub_container2_trading")}}</h3>
                                  
                            </div>
                            <div class="flip-card-back">
                                <p class="mb-4">{{$t("demo_account.sub_heading1_sub_container2_description")}}</p>
                            </div>
                            </div>
                        </div>
                    </div>
                    <!-- item -->
                    <div class="col-md-6 col-lg-3 py-3" data-aos="fade-up" data-aos-duration="600" data-aos-delay="700">
                        <div class="flip-card" tabIndex="0">
                            <div class="flip-card-inner text-center">
                            <div class="flip-card-front">
                                <img class="img-fluid mb-4" src="/static/fxView/images/lp/featurethree.svg">
                                <h3 class="titleColor fs20 fw-semiBold mb-3 pt-3">{{$t("demo_account.sub_heading1_sub_container3_hundreds_of")}} <br>{{$t("demo_account.sub_heading1_sub_container3_tradable_instruments")}}</h3>
                                    
                            </div>
                            <div class="flip-card-back">
                                <p class="mb-4">{{$t("demo_account.sub_heading1_sub_container3_description")}}</p>                             
                            </div>
                            </div>
                        </div>
                    </div>

                    <!-- item -->
                    <div class="col-md-6 col-lg-3 py-3" data-aos="fade-up" data-aos-duration="600" data-aos-delay="800">
                        <div class="flip-card" tabIndex="0">
                            <div class="flip-card-inner text-center">
                            <div class="flip-card-front">
                                <img class="img-fluid mb-4" src="/static/fxView/images/lp/featurefour.svg">
                                <h3 class="titleColor fs20 fw-semiBold mb-3 pt-3">{{$t("demo_account.sub_heading1_sub_container4_real_prices_with")}} <br>{{$t("demo_account.sub_heading1_sub_container4_fast_execution")}}</h3>
                            </div>
                            <div class="flip-card-back">
                                <p class="mb-4">{{$t("demo_account.sub_heading1_sub_container4_description")}}</p>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: 'sectionScnd'
}
</script>



// WEBPACK FOOTER //
// src/components/fxView/lp/pageSections/section-1.vue